'use es6';

export const getAwardsRequestState = state => state.awards.requestState;
export const getAwards = state => state.awards.data;